import React, {Component} from 'react';
import {Elements} from 'react-stripe-elements';
import NestedStripe from "./NestedStripe";
import PropTypes from "prop-types";
import {connect} from "react-redux";

class Stripe extends Component {
    render() {
        return (
            <Elements>
                <NestedStripe
                    intent={this.props.paymentIntent}
                    className={this.props.className}
                    onSubmit={this.props.onSubmit}
                />
            </Elements>
        );
    }
}

const mapStateToProps = state => ({
    paymentIntent: state.transactionsReducer.paymentIntent
});

export default connect(mapStateToProps)(Stripe);

Stripe.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};
